import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	update (id, data) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/event/seats/' + id, data).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/event/seat.js